import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { AppContext } from "./AppContext";
import "./css/custom.scss";
import { RestAttributeCacheInputBean, RestReadRequest } from "./ds/ds.js";
import Footer from "./gui_components/Footer.js";
import CrashSite from "./modules/CrashSite";
import MainModule from "./modules/MainModule.js";
import NotFound from "./modules/NotFound.js";
import UserSignInModule from "./modules/UserSignInModule.js";
import ErrorBoundary from "./gui_components/ErrorBoundary";

const AppRoutes = (props) => {
  const [appData, setAppData] = useState({});

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = "";

      const session = JSON.parse(localStorage.getItem("session"));
      if (session !== null && session !== undefined) {
        //const navigate = useNavigate();
        const { companyCode, code } = session;
        let request = new RestReadRequest();
        request.companyCode = companyCode;
        request.code = code;
        const _url = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LOGIN_SERVICE_PATH}/logoutBasedOnUser`;
        axios({
          method: "post",
          url: _url,
          data: request,
          headers: {
            "Access-Control-Allow-Origin": "*",
            securitykey: localStorage.getItem("security_token"),
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            //navigate('/login');
          })
          .catch((error) => {
            console.log("Erro : " + error);
          });
      }
      //TODO : remove all items in storage.
      localStorage.removeItem("security_token");
      localStorage.removeItem("configs");
      localStorage.removeItem("attributeCache");
      localStorage.removeItem("companyConfig");
      localStorage.removeItem("session");
      localStorage.removeItem("entitlements");

      //return <Navigate to="/logout" />;
      return <Navigate to="/login" />;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LOGIN_SERVICE_PATH}/getInitialValues`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        securitykey: "RESTTEST1234",
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response != null && response.data != null) {
          if (response.data.isSuccess) {
            const appData = response.data;

            //appData.companyCode = "3PL";
            // appData.companyCode = "RAMTEX";
            // appData.applicationMode=RAMTEX
            // appData.themeType=0
            // appData.applicationName = "FABRIC APP"
            // appData.applicationMainImagePath = ""
            // appData.guiVersion = 1
            // appData.serverVersion = 1
            // appData.applicationLogoImagePath = ""
            appData.serviceURL = process.env.REACT_APP_API_URL;
            appData.reportURL =
              appData.serviceURL + `/${process.env.REACT_APP_REPORT_PATH}`;
            appData.imageURL =
              appData.serviceURL + `/${process.env.REACT_APP_IMAGE_PATH}`;
            setAppData(appData);
            /* to change ttile dynamically */
            document.title = appData.applicationName;

            /* get attribute cache */

            const request = new RestAttributeCacheInputBean();
            request.companyCode = appData.companyCode;
            axios({
              method: "post",
              url: `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_MASTER_SERVICE_PATH}/getAttributeCache`,
              data: request,
              headers: {
                "Access-Control-Allow-Origin": "*",
                securitykey: "RESTTEST1234",
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                if (response != null && response.data != null) {
                  if (response.data.isSuccess) {
                    console.log(
                      "cache : approutes ",
                      response.data.attributeCache
                    );
                    setAppData({
                      ...appData,
                      cache: { ...response.data.attributeCache },
                    });
                  }
                } else {
                  console.log("Unable to Load Cache!");
                  setAppData({
                    ...appData,
                    cache: {},
                  });
                }
              })
              .catch((error) => {
                console.log("Erro : " + error);
              });
          }
        }
      })
      .catch((error) => {
        console.log("Erro : " + error);
      });

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const authGuard = (Component) => () => {
    return localStorage.getItem("security_token") ? (
      <AppContext.Provider value={{ appData, setAppData }}>
        <ErrorBoundary>
          <Component appData={appData} setAppData={setAppData} />
        </ErrorBoundary>
        <Footer />
      </AppContext.Provider>
    ) : (
      <Navigate  to="/login" />
    );
  };

  const Logout = () => () => {
    const session = JSON.parse(localStorage.getItem("session"));
    if (session !== null && session !== undefined) {
      //const navigate = useNavigate();

      const { companyCode, code } = session;
      let request = new RestReadRequest();
      request.companyCode = companyCode;
      request.code = code;
      const _url = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LOGIN_SERVICE_PATH}/logoutBasedOnUser`;
      axios({
        method: "post",
        url: _url,
        data: request,
        headers: {
          "Access-Control-Allow-Origin": "*",
          securitykey: localStorage.getItem("security_token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          //navigate('/login');
        })
        .catch((error) => {
          console.log("Erro : " + error);
        });
    }
    //TODO : remove all items in storage.
    localStorage.removeItem("security_token");
    localStorage.removeItem("configs");
    localStorage.removeItem("attributeCache");
    localStorage.removeItem("companyConfig");
    localStorage.removeItem("session");
    localStorage.removeItem("entitlements");
    return <Navigate  to="/login" />;
  };

  const AuthGuardWithMain = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return localStorage.getItem("security_token") ? (
      <>
        <ErrorBoundary>
          <MainModule
            appData={appData}
            setAppData={setAppData}
            location={location}
            navigate={navigate}
            params={params}
          ></MainModule>
        </ErrorBoundary>
        <Footer />
      </>
    ) : (
      <Navigate to="/login" />
    );
  };

  const PrivateRoute = ({ children, ...rest }) => {
    const auth = true;
    return auth ? children : <Navigate to="/login" />;
  };

  const PrivateRouteLogin = () => {
    return <Navigate to="/login" />;
  };

  const PrivateRouteLogout = () => {
    Logout();
    return <Navigate to="/login" />;
  };  

  return (
    <Router {...props}>
      <Routes>
        <Route
        path="/logout"
        element={
          <PrivateRouteLogout/>
        }
        />
        <Route
        path="/Logout"
        element={
          <PrivateRouteLogout/>
        }
        />
        <Route
    path="/login"
    element={
      <AppContext.Provider value={{ appData, setAppData }}>
        <UserSignInModule />
      </AppContext.Provider>
    }
  />    
  <Route path="/main" element={<PrivateRoute><AuthGuardWithMain/></PrivateRoute>} />
  <Route exact path="/" element={<PrivateRouteLogin/>} />
  <Route path="*" element={<NotFound />}/>
  </Routes>
  </Router>
  );
};
export default AppRoutes;
